import { Component, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { FileVm } from '../../Models/fileVm';

export class AddingWithAttatchementsBaseComponent implements OnInit {
  attachments: any = new FormData();
  constructor(public service: any, public dialog: NbDialogService = null) {}

  ngOnInit() {}

  uploadFile(files: FileVm[]) {
    for (let file of files) {
     this.attachments.append(file.fileName, file);
    }
  }
  uploadFilee(file: FileVm) {
        console.log("enter to upload file")
    
     this.attachments.append(file.fileName, file);
    
  }
  save(model, fileId = 'attachements', formData, attachements, saveCF) {
    let fileInput = document.getElementById(fileId) as any;

    this.service.uploadFile(formData).subscribe((res) => {
      model.thumbnail = {} as FileVm;
      model.thumbnail.fileName = res.fileName;
      formData.forEach((file) => {
        model.thumbnail.originalFileName = file.valueOf()['name'];
      });

      if (fileInput.files.length > 0) {
        this.service.uploadMultipleFiles(attachements).subscribe((res) => {
          model.attachements = [];
          res.forEach((element, index) => {
            model.attachements.push({
              fileName: element,
              originalFileName: fileInput.files[index].name,
            } as FileVm);
          });

          saveCF();
        });
      } else {
        saveCF();
      }
    });
  }

  uploadFileService(formData, model, callbackFunction) {
    if (!this.isFormDataEmpty(formData)) {
      this.service.uploadFile(formData).subscribe((res) => {
        model.thumbnail = {} as FileVm;
        model.thumbnail.fileName = res.fileName;
        formData.forEach((file) => {
          model.thumbnail.originalFileName = file.valueOf()['name'];
        });

        callbackFunction(model);
      });
    } else {
      callbackFunction(model);
    }
  }

  uploadMultipleFilesService(attachements, model, fileId, callbackFunction) {
    // let fileInput = document.getElementById(fileId) as any;
    let hasEntries = false;
    this.attachments.forEach(() => {
      hasEntries = true;
    });
    if (hasEntries) {
      this.service.uploadMultipleFiles(attachements).subscribe((res) => {
        model.attachements = [];
        res.forEach((element, index) => {
          model.attachements.push({
            fileName: element,
            originalFileName: element.name,
          } as FileVm);
        });

        callbackFunction();
      });
    } else {
      callbackFunction();
    }
  }

  isFormDataEmpty(formData) {
    formData.forEach((_) => {
      return true;
    });
    return false;
  }

  saveWithAttachements(model, fileId = 'attachements', formData, attachements, saveCF) {
    console.log('1');
    if (!this.isFormDataEmpty(formData)) {
      this.uploadFileService(formData, model, () => {
        this.uploadMultipleFilesService(attachements, model, fileId, () => {
          console.log('3');

          saveCF(model);
        });
      });
    }
  }
}
